import StoreDefinition from '../StoreDefinition'
import { api } from '../../plugins/axios'

export default new StoreDefinition()
  .prop('types')
  .action('fetch', ({ commit, getters }) => {
    if (getters.types) {
      return Promise.resolve(getters.types)
    }

    return api
      .get('/embed/material-types')
      .then(types => {
        if (types) {
          commit('setTypes', types)
        }

        return types
      })
  })
  .end()
